import angular from 'angular'

import template from './simple.html'
import SimpleModalController from './simple.controller'
/**
 * A simple modal dialog, with header and content (no button bar).
 *
 * @param {object} options The simple modal options. Will also be passed to the modal and be exposed to the template as
 * `modalCtrl.options`.
 *
 * @param {string} options.header The dialog header.
 *
 * @param {html} options.content The dialog content.
 *
 * @example
 * <script>
 *   function SimpleDemoCtrl($scope, $timeout, SimpleModal) {
 *     $scope.open = function(resolve) {
 *       SimpleModal({
 *         header: 'Do you want to launch Doomsday Machine?',
 *         content: 'Ready to end life on earth?'
 *       })
 *     }
 *     $scope.openAsync = function() {
 *       $scope.open($timeout(function(){}, 2000))
 *     }
 *   }
 * </script>
 * <div ng-controller="SimpleDemoCtrl">
 *   <button class="vd-btn vd-btn--do" ng-click="open()">Open simple modal</button>
 *   <button class="vd-btn vd-btn--do" ng-click="openAsync()">Open async simple modal</button>
 * </div>
 */
angular.module('vend.ui').factory('SimpleModal', function (Modal) {
  return function (options) {
    options.controller = SimpleModalController
    options.template = template
    return Modal(options)
  }
})
